import type { ListStoresResponse, StoreSummaryDto, OwnerEntity } from '@bhops/shared';
import { apiClient } from './client';

export interface ListStoresQuery {
  customerId?: string;
  search?: string;
  page?: number;
  pageSize?: number;
  includeInactive?: boolean;
  // Round 2 Phase F (#8) — true 면 "배정 가능"(계약 완료 ~ 설치 완료) 고객사의
  // 매장만 반환(고객사 없는 매장 제외). 배치 모달의 "배정 가능 고객사만" 토글.
  assignableOnly?: boolean;
  // data-lifecycle §3 — 삭제됨(soft-delete) 포함(삭제 권한자 전용; 서버에서 확인).
  includeDeleted?: boolean;
}

export interface CreateStoreBody {
  name: string;
  branchName?: string;
  parentStoreId?: string;
  customerId?: string;
  addressLine1?: string;
  city?: string;
  region?: string;
  postalCode?: string;
  country?: string;
  ownerEntity: OwnerEntity;
  notes?: string;
}

export const storesApi = {
  async list(query: ListStoresQuery = {}): Promise<ListStoresResponse> {
    const { data } = await apiClient.get<ListStoresResponse>('/stores', { params: query });
    return data;
  },
  async get(id: string): Promise<StoreSummaryDto> {
    const { data } = await apiClient.get<StoreSummaryDto>(`/stores/${id}`);
    return data;
  },
  async create(body: CreateStoreBody): Promise<StoreSummaryDto> {
    const { data } = await apiClient.post<StoreSummaryDto>('/stores', body);
    return data;
  },
  async update(id: string, body: UpdateStoreBody): Promise<StoreSummaryDto> {
    const { data } = await apiClient.patch<StoreSummaryDto>(`/stores/${id}`, body);
    return data;
  },
  // data-lifecycle §3 — soft-delete 복구(셀프). 삭제 권한자가 직접 복구.
  async restore(id: string): Promise<StoreSummaryDto> {
    const { data } = await apiClient.post<StoreSummaryDto>(
      `/stores/${encodeURIComponent(id)}/restore`,
    );
    return data;
  },
};

export interface UpdateStoreBody {
  name?: string;
  branchName?: string | null;
  parentStoreId?: string | null;
  customerId?: string | null;
  addressLine1?: string | null;
  city?: string | null;
  region?: string | null;
  postalCode?: string | null;
  country?: string;
  active?: boolean;
  notes?: string | null;
}
